export default __webpack_public_path__ + "static/media/spiral.fd70ba4e.png";